{
    "id":  "skirmish_03",
    "name":  "Skirmish-03",
    "mode":  "HOTSEAT_2P",
    "ruleset":  "OFFICIAL_SKIRMISH",
    "orientation":  "POINTY_TOP",
    "objective":  "Oficiální cíl: soupeř prohrává, když mu nezůstane žádná figurka.",
    "randomStart":  true,
    "credits":  {
                    "EFA":  20,
                    "REDCAT":  20
                },
    "terrain":  [
                    "VVVVVVVVVVVVVVVVVVV",
                    "DDDDDDDDDDDDDDDDDDV",
                    "VDDDDDDNDDDNDDDDDDV",
                    "DDNDDDDDDDDDDDDNDDV",
                    "VDNDDDDDDDDDDDDDNDV",
                    "DDDDDDDDDDDDDDDDDDV",
                    "VDDDDDNDDDDDNDDDDDV",
                    "DDDDDNDDDDDDNDDDDDV",
                    "VDFDDDDDDDDDDDDDFDV",
                    "DDDDFDDDNNDDDFDDDDV",
                    "VDDDDDDDDDDDDDDDDDV"
                ],
    "ore":  [
                [
                    0,
                    1
                ],
                [
                    1,
                    1
                ],
                [
                    5,
                    1
                ],
                [
                    6,
                    1
                ],
                [
                    6,
                    2
                ],
                [
                    11,
                    1
                ],
                [
                    12,
                    1
                ],
                [
                    12,
                    2
                ],
                [
                    16,
                    1
                ],
                [
                    17,
                    1
                ],
                [
                    0,
                    9
                ],
                [
                    1,
                    10
                ],
                [
                    8,
                    10
                ],
                [
                    9,
                    10
                ],
                [
                    10,
                    10
                ],
                [
                    17,
                    9
                ],
                [
                    17,
                    10
                ]
            ],
    "pieces":  [
                   {
                       "type":  "MCV",
                       "owner":  "EFA",
                       "col":  0,
                       "row":  5
                   },
                   {
                       "type":  "MCV",
                       "owner":  "REDCAT",
                       "col":  17,
                       "row":  5
                   }
               ]
}
